export default "__VITE_ASSET__c7f09a79__"